import axios from "@/lib/axios";

/**
 * 首页数据
 */
export const getHomePageData = () => {
  return axios.request({
    url: "/langchao/homePage/getHomePageData",
    method: "get",
  });
};
/**
 * 设备运维首页数据
 *
 */
export const getOperationHomePageData = () => {
  return axios.request({
    url: "/langchao/operation/getOperationHomePageData",
    method: "get",
  });
};
/**
 * 环境监测首页数据
 *
 */
export const getEnvironmentHomePage = () => {
  return axios.request({
    url: "/langchao/environment/getEnvironmentHomePage",
  });
};
/**
 * 能耗管理首页数据
 *
 */
export const getEnergyData = () => {
  return axios.request({
    url: "/langchao/energy/getEnergyData",
  });
};
/**
 * 设备信息
 *
 */
export const getEqpInfo = ({ eqpCode }) => {
  return axios.request({
    url: "/langchao/base/getEqpInfo",
    params: {
      eqpCode,
    },
  });
};
/**
 * 能耗管理水能耗首页数据
 *
 */
export const getWaterEnergyData = () => {
  return axios.request({
    url: "/langchao/energy/getWaterEnergyData",
  });
};

/**
 * 能耗管理电能耗首页数据
 *
 */
export const getElectricityEnergyData = () => {
  return axios.request({
    url: "/langchao/energy/getElectricityEnergyData",
  });
};

/**
 * 告警中心
 *
 */
export const getAlarmData = () => {
  return axios.request({
    url: "/langchao/alarm/getAlarmData",
  });
};
/**
 * 停车管理
 *
 */

export const getParkData = () => {
  return axios.request({
    url: "/langchao/park/getParkData",
  });
};
/**
 * 给排水
 *
 */

export const getWaterSupply = () => {
  return axios.request({
    url: "/langchao/operation/queryWaterSupplyData",
  });
};
/**
 * 变配电
 *
 */

export const getPowerSupplyData = () => {
  return axios.request({
    url: "/langchao/operation/getPowerSupplyData",
  });
};
/**
 * 空调
 *
 */

export const getAirData = () => {
  return axios.request({
    url: "/langchao/operation/getAirData",
  });
};
/**
 * 电梯
 *
 */

export const getElevatorData = () => {
  return axios.request({
    url: "/langchao/operation/getElevatorData",
  });
};

/**
 * 消防
 *
 */
export const getFireControlData = () => {
  return axios.request({
    url: "/langchao/operation/getFireControlData",
  });
};

/**
 * 水能耗
 *
 */
export const getWaterEnergyDataByArea = () => {
  return axios.request({
    url: "/langchao/energy/getWaterEnergyDataByArea",
  });
};
/**
 * 电能耗
 *
 */
export const getElectricityEnergyDataByArea = () => {
  return axios.request({
    url: "/langchao/energy/getElectricityEnergyDataByArea",
  });
};
/**
 * 监控
 *
 */
export const getMonitorData = () => {
  return axios.request({
    url: "/langchao/monitor/getMonitorData",
  });
};
/**
 * 网关
 *
 */
export const getGatewayData = () => {
  return axios.request({
    url: "/langchao/operation/queryGatewayData",
  });
};
/**
 * 告警历史记录
 *
 */
export const getAlarmDataHistorical = (params) => {
  return axios.request({
    url: "langchao/alarm/getAlarmDataHistorical",
    params
  });
};
/**
 * 获取每层楼设备状态
 *
 */
export const getEqpStatus = (params) => {
  return axios.request({
    url: "langchao/base/getEqpStatus",
    params
  });
};

/**
 * 获取停车信息
 *
 */
export const getParkByPlate = (params) => {
  return axios.request({
    url: 'langchao/park/getParkByPlate',
    params
  })
}

/**
 * 获取变配电信息
 *
 */
export const getEqpByName = (params) => {
  return axios.request({
    url: 'langchao/operation/getEqpByName',
    params
  })
}
/**
 * 获取商户信息
 *
 */
export const getMerchanName = () => {
  return axios.request({
    url: 'langchao/energy/queryMerchantName',
  })
}

/**
 * 异常楼层
 *
 */
export const getAlarmBuildNo = (params) => {
  return axios.request({
    url: "/langchao/base/getAlarmBuildNo",
    params
  });
};

/**
 * 楼层弹框
 *
 */
export const getEqpStatusByBuildNo = (params) => {
  return axios.request({
    url: "/langchao/base/getEqpStatusByBuildNo",
    params
  });
};
/**
 * 照明
 *
 */
export const getIllumination = () => {
  return axios.request({
    url: "/langchao/operation/getIllumination",
  });
};

